//========== Banner Section Component ==========

import { useState, useEffect, useCallback, useMemo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../../assets/img/Background-img/banner-img.svg";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "animate.css";
import TrackVisibility from "react-on-screen";
import "./banner.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const style = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
};
const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(150 - Math.random() * 50);
  const toRotate = useMemo(() => ["Front-End Developer", "Web Designer", "Software Engineer"], []);
  const period = 1000;
  const tick = useCallback(() => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);
    setText(updatedText);
    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }
    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(250);
    }
  }, [text, isDeleting, loopNum, toRotate, period]);
  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);
    return () => clearInterval(ticker);
  }, [tick, delta]);
  return /*#__PURE__*/_jsx("section", {
    className: "banner",
    id: "home",
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        className: "align-items-center",
        children: [/*#__PURE__*/_jsx(Col, {
          xs: 12,
          md: 6,
          xl: 7,
          children: /*#__PURE__*/_jsx(TrackVisibility, {
            children: ({
              isVisible
            }) => /*#__PURE__*/_jsxs("div", {
              className: isVisible ? "animate__animated animate__fadeIn dataSection" : "",
              children: [/*#__PURE__*/_jsxs("span", {
                className: "welcome-message",
                "data-text": "Welcome to my",
                children: ["Welcome to my", " ", /*#__PURE__*/_jsx("span", {
                  className: "welcomeSpan",
                  children: " Portfolio "
                })]
              }), /*#__PURE__*/_jsx("h1", {
                children: `Hi! I'm Mohamed`
              }), /*#__PURE__*/_jsx("div", {
                className: "txt-rotate typograph",
                style: {
                  ...style,
                  minHeight: "1em"
                },
                children: /*#__PURE__*/_jsx("span", {
                  className: "wrap",
                  children: text
                })
              }), /*#__PURE__*/_jsxs("a", {
                href: "#about",
                className: "btn",
                children: [/*#__PURE__*/_jsx("span", {
                  children: "About Me"
                }), /*#__PURE__*/_jsx("i", {
                  className: "fas fa-arrow-circle-down"
                })]
              }), /*#__PURE__*/_jsx("div", {
                className: "socials",
                children: /*#__PURE__*/_jsxs("ul", {
                  className: "social-icons",
                  children: [/*#__PURE__*/_jsx("li", {
                    children: /*#__PURE__*/_jsx("a", {
                      className: "linkedin",
                      "aria-label": "LinkedIn",
                      href: "https://www.linkedin.com/in/mohamed-salem149",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      children: /*#__PURE__*/_jsx("i", {
                        className: "fab fa-linkedin"
                      })
                    })
                  }), /*#__PURE__*/_jsx("li", {
                    children: /*#__PURE__*/_jsx("a", {
                      className: "github",
                      "aria-label": "GitHub",
                      href: "https://github.com/MoSalem149",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      children: /*#__PURE__*/_jsx("i", {
                        className: "fab fa-github"
                      })
                    })
                  }), /*#__PURE__*/_jsx("li", {
                    children: /*#__PURE__*/_jsx("a", {
                      className: "twitter",
                      "aria-label": "Twitter",
                      href: "https://twitter.com/MohamedSalem149",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      children: /*#__PURE__*/_jsx("i", {
                        className: "fa-brands fa-x-twitter"
                      })
                    })
                  }), /*#__PURE__*/_jsx("li", {
                    children: /*#__PURE__*/_jsx("a", {
                      className: "telegram",
                      "aria-label": "Telegram",
                      href: "https://t.me/MoSalem149",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      children: /*#__PURE__*/_jsx("i", {
                        className: "fab fa-telegram-plane"
                      })
                    })
                  }), /*#__PURE__*/_jsx("li", {
                    children: /*#__PURE__*/_jsx("a", {
                      className: "facebook",
                      "aria-label": "Facebook",
                      href: "https://www.facebook.com/MoSalem149",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      children: /*#__PURE__*/_jsx("i", {
                        className: "fab fa-facebook"
                      })
                    })
                  }), /*#__PURE__*/_jsx("li", {
                    children: /*#__PURE__*/_jsx("a", {
                      className: "email",
                      "aria-label": "Email",
                      href: "mailto:mohamed.salem.dev.official@gmail.com",
                      children: /*#__PURE__*/_jsx("i", {
                        className: "fas fa-envelope"
                      })
                    })
                  })]
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          xs: 12,
          md: 6,
          xl: 5,
          children: /*#__PURE__*/_jsx(TrackVisibility, {
            children: ({
              isVisible
            }) => /*#__PURE__*/_jsx("div", {
              className: isVisible ? "animate__animated animate__zoomIn" : "",
              children: /*#__PURE__*/_jsx("img", {
                src: headerImg,
                alt: "Banner Img"
              })
            })
          })
        })]
      })
    })
  });
};
export default Banner;